module.exports = __webpack_public_path__ + "img/verification-man.969d4eca.svg";